module.exports = __webpack_public_path__ + "img/rocket.db419c36.svg";